import React from 'react';
import { Link, useLocation } from 'react-router-dom';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const location = useLocation();
  const navItems = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/explore',
    label: 'Explore Stories'
  }, {
    path: '/explore-brands',
    label: 'Explore Publishers'
  }, {
    path: '/republished',
    label: 'Republished'
  }, {
    path: '/analytics',
    label: 'Analytics'
  }, {
    path: '/settings',
    label: 'Settings'
  }];
  return <div className="flex h-screen w-full bg-gradient-to-br from-blue-50 via-white to-blue-50" data-id="element-114">
      {/* Sidebar */}
      <aside className="w-72 bg-white border-r border-neutral-200 flex flex-col shadow-lg" data-id="element-115">
        <div className="pt-8 pr-8 pb-8 pl-4 border-b border-neutral-200" style={{
        backgroundColor: '#182941'
      }} data-id="element-116">
          <div className="flex items-center gap-4" data-id="element-117">
            <img src="https://inn.org/wp-content/uploads/2022/01/INN-SQUARES-Logo.png" alt="INN Logo" className="w-20 h-20 object-contain flex-shrink-0" data-id="element-118" />
            <div data-id="element-119">
              <h1 className="text-2xl font-bold text-display text-white leading-tight" data-id="element-120">
                INN
              </h1>
              <h1 className="text-lg font-semibold text-white leading-tight whitespace-nowrap" data-id="element-121">
                Content Exchange
              </h1>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-6 space-y-2" data-id="element-122">
          {navItems.map(item => <Link key={item.path} to={item.path} className={`block px-4 py-3 text-sm font-medium rounded-lg transition-all ${location.pathname === item.path ? 'text-white shadow-sm' : 'text-neutral-700 hover:bg-neutral-50'}`} style={location.pathname === item.path ? {
          background: 'linear-gradient(135deg, #26aedb 0%, #0289BB 50%, #0277a8 100%)'
        } : {}} data-id="element-123">
              {item.label}
            </Link>)}
        </nav>
        <div className="p-6 border-t border-neutral-200" data-id="element-124">
          <div className="flex items-center gap-3" data-id="element-125">
            <div className="w-10 h-10 rounded-full flex items-center justify-center shadow-md" style={{
            backgroundColor: '#182941'
          }} data-id="element-126">
              <span className="text-white font-semibold text-sm" data-id="element-127">AD</span>
            </div>
            <div className="flex-1 min-w-0" data-id="element-128">
              <p className="text-sm font-medium text-neutral-900 truncate" data-id="element-129">
                Admin User
              </p>
              <p className="text-xs text-neutral-500 truncate" data-id="element-130">admin@inn.org</p>
            </div>
          </div>
        </div>
      </aside>
      {/* Main Content */}
      <main className="flex-1 overflow-auto" data-id="element-131">
        <div className="max-w-7xl mx-auto p-8" data-id="element-132">{children}</div>
      </main>
    </div>;
}